module.exports = __webpack_public_path__ + "static/vf_wtop_core.cb05e772.svg";